export class PrizesRoutingNames {
    public static readonly NAME_BASE = '';
    public static readonly NAME_PRIZE = 'prize';

    public static readonly ROUTE_BASE = `/${PrizesRoutingNames.NAME_BASE}`;
    public static readonly ROUTE_PRIZE = `/${PrizesRoutingNames.NAME_PRIZE}`;
}
